import React from 'react';
import { DiaryEntry } from './DiaryEntry';
import { InlineCTA } from './InlineCTA';
import { motion } from 'framer-motion';
export function DiarySection() {
  return <section className="max-w-3xl mx-auto px-6 py-12" data-id="element-32">
      <DiaryEntry date="15. Dezember 2024" title="Das Problem" delay={0.1} content={<div className="space-y-6" data-id="element-34">
            <p className="font-[400]" data-id="element-35">
              Max frisst morgens sein Futter und danach beginnt das Würgen. Er
              steht im Garten und <strong data-id="element-36">frisst ständig Gras</strong>, als gäbe
              es kein Morgen mehr. Er schläft schlecht, wälzt sich nachts
              unruhig hin und her und schmatzt laut.
            </p>
            <p className="font-[400]" data-id="element-37">
              Der Tierarzt findet nichts. "Das ist bei manchen Hunden einfach
              so, vielleicht ein <strong data-id="element-38">empfindlicher Magen</strong>", heißt
              es. Ein zweiter Tierarzt verschreibt Säureblocker, die kurzfristig
              helfen, aber sobald wir sie absetzen, ist alles wieder beim Alten.
            </p>
            <p className="font-[400]" data-id="element-39">
              Ich bin verzweifelt. Es kann doch nicht normal sein, dass mein{' '}
              <strong data-id="element-40">Hund nach jeder Mahlzeit leidet</strong>. Ich verbringe
              Nächte damit, Foren zu durchforsten, wechsle das Futter dreimal,
              koche Schonkost – nichts bringt dauerhaft Ruhe in seinen Bauch.
            </p>
          </div>} data-id="element-33" />

      <DiaryEntry date="28. Januar 2025" title="Der Wendepunkt" delay={0.2} content={<div className="space-y-6" data-id="element-42">
            <p data-id="element-43">
              Eine Hundemama aus meinem lokalen Hunde-Forum erwähnt beiläufig
              ein <strong data-id="element-44">natürliches Futtertopping</strong>. Sie hatte mit
              ihrem Golden Retriever ähnliche Probleme und schwört auf eine
              Mischung mit Mariendistel, Topinambur und Präbiotika.
            </p>
            <p data-id="element-45">
              Ich bin ehrlich gesagt skeptisch. Nach all dem Geld, das ich beim
              Tierarzt und für Spezialfutter gelassen habe,{' '}
              <strong data-id="element-46">soll ein einfaches Pulver die Lösung sein?</strong> Aber
              dann sah ich, dass schon über 870 andere Hundehalter das Topping
              bewertet hatten – die meisten mit ähnlichen Problemen wie Max.
              Wenn man verzweifelt ist, greift man nach jedem Strohhalm.
            </p>
            <p data-id="element-47">
              Ich bestelle es. Was kann ich schon verlieren? Es ist{' '}
              <strong data-id="element-48">100% pflanzlich</strong>, also kann es zumindest nicht
              schaden. Als das Paket ankommt, mische ich am Abend den ersten
              Löffel unter sein Futter. Max schnuppert kurz und frisst dann
              alles restlos auf. Ein guter Anfang.
            </p>
          </div>} data-id="element-41" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="my-12 py-8 px-6 sm:px-10 bg-brand-paper border-l-4 border-brand-amber shadow-sm rounded-r-lg" data-id="element-49">
        <p className="text-xl sm:text-2xl font-serif italic text-stone-700 text-center leading-relaxed" data-id="element-50">
          "Wenn man verzweifelt ist, greift man nach jedem Strohhalm."
        </p>
      </motion.div>

      <DiaryEntry date="25. Februar 2025" title="Die Veränderung" delay={0.3} content={<div className="space-y-6" data-id="element-52">
            <p data-id="element-53">
              Nach 10 Tagen bemerke ich die erste Veränderung: Max frisst Gras
              deutlich seltener. Er steht nach dem Fressen nicht mehr sofort
              auf, um in den Garten zu rennen.
            </p>
            <p data-id="element-54">
              Jetzt, nach 3 Wochen, wage ich es kaum laut auszusprechen:{' '}
              <strong data-id="element-55">Kein nächtliches Würgen mehr.</strong> Nichts. Er schläft
              durch, eingerollt in seinem Körbchen, ohne Schmatzen, ohne Unruhe.
              Er frisst sein Futter wieder entspannt und freut sich sogar
              darauf.
            </p>
            <p data-id="element-56">
              Ich kann es wirklich kaum glauben.{' '}
              <strong data-id="element-57">
                Ich habe meinen fröhlichen, unbeschwerten Hund zurück.
              </strong>{' '}
              Wenn ich gewusst hätte, dass die Lösung so einfach und natürlich
              sein kann, hätte ich uns beiden monatelangen Stress erspart.
            </p>
          </div>} data-id="element-51" />

      <InlineCTA label="Das Topping das Max geholfen hat → hier testen" position="story_cta" data-id="element-58" />
    </section>;
}